import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-weight: 700;\n  font-feature-settings: 'zero' on, 'ss02' on, 'ss06' on, 'ss05' on;\n\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n\n  body:lang(ja) & {\n    font-family: ",
        ";\n    font-feature-settings: normal;\n  }\n\n  body:lang(ru) & {\n    font-family: ",
        ";\n    font-feature-settings: 'ss03';\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { convertLayoutProps } from "../../utils";
var HeadingElement = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var tmp = props.as, Element = tmp === void 0 ? "div" : tmp, children = props.children, restProps = _object_without_properties(props, [
        "as",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Element, _object_spread_props(_object_spread({
        ref: ref
    }, restProps), {
        children: children
    }));
});
HeadingElement.displayName = "HeadingElement";
var HeadingBase = styled(HeadingElement).withConfig({
    componentId: "sc-e39540af-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.fonts.spoof;
}, function(param) {
    var theme = param.theme;
    return theme.fonts.mPlus1;
}, function(param) {
    var theme = param.theme;
    var ref;
    return theme === null || theme === void 0 ? void 0 : (ref = theme.fonts) === null || ref === void 0 ? void 0 : ref.formular;
});
HeadingBase.displayName = "HeadingBase";
var Heading = styled(HeadingBase).withConfig({
    componentId: "sc-e39540af-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, _color = param.color, color = _color === void 0 ? "primaryIndigo" : _color;
    return theme.colors[color];
}, function(_param) {
    var theme = _param.theme, $styles = _param.$styles, $align = _param.$align, props = _object_without_properties(_param, [
        "theme",
        "$styles",
        "$align"
    ]);
    return theme.normalizeStyles(_object_spread(_object_spread_props(_object_spread({}, convertLayoutProps(props)), {
        textAlign: $align
    }), $styles));
}, function(param) {
    var theme = param.theme, $variant = param.$variant;
    return $variant && theme.expandVariants($variant, theme.typography.heading);
});
Heading.displayName = "Heading";
export default Heading;
